import { Box, Grid, Typography } from "@mui/material";
import { useMessage } from "hooks/intl";
import { TransactionItem, TransactionItemFilterType } from "types/campaigns";
import { NewFormatConditionReadOnly } from "../../../Common/CampaignRules/Rule/Conditions/NewFormatConditions/NewFormatConditionReadOnly";
import { itemFilters } from "../../CampaignForm/Rules/TransactionItemFilters/helpers";
import { useStyles } from "./CampaignDetails";

interface Props {
  transactionItemsFilters?: TransactionItem[];
}

export const TransactionFiltersSection = ({
  transactionItemsFilters,
}: Props) => {
  const classes = useStyles();
  const { message } = useMessage();

  const formattedTransactionItemsFilters = transactionItemsFilters?.map(
    ({ name, code, filters }) => ({
      name,
      code,
      filters: filters.map(({ value, condition }) => ({
        value,
        condition,
        type: itemFilters.find(({ id }) => value.field === id)?.type,
        label: itemFilters.find(({ id }) => value.field === id)?.label,
        isSaved: true,
        isEditMode: false,
      })),
    }),
  );

  return (
    <Grid container className={classes.gridContainer}>
      <Grid className={classes.gridChild} item xs={12}>
        <span
          className={classes.header}
          data-test-id={`single-campaign-transaction-filters-header`}
        >
          {message({
            id: "transactionFilters",
          })}
        </span>
        {formattedTransactionItemsFilters?.map((itemFilter) => (
          <Box
            className={classes.rule}
            data-test-id={`single-campaign-transaction-filter-${itemFilter.code}`}
            key={itemFilter.code}
          >
            <Box className={classes.ruleHeader}>
              <Typography className={classes.ruleTitle}>
                {itemFilter.name}
              </Typography>
            </Box>
            <span className={classes.ruleContent}>
              <span className={classes.conditionsHeader}>
                {message({ id: "conditions" })}
              </span>
              <span>
                {itemFilter?.filters?.map((condition, index) => {
                  const dataTestId = `single-campaign-transaction-filter-${
                    itemFilter.code
                  }-condition-${index + 1}`;

                  return (
                    <>
                      <div className={classes.readOnlyWrapper}>
                        <span>{index + 1}.</span>
                        <NewFormatConditionReadOnly
                          conditionObject={
                            condition as TransactionItemFilterType
                          }
                          data-test-id={dataTestId}
                        />
                      </div>
                    </>
                  );
                })}
              </span>
            </span>
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};
